module.exports = __webpack_public_path__ + "img/gs.1766306608134.png";